export default __webpack_public_path__ + "static/media/icon_reduce.101e3225.svg";